import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './OnboardingNotification.css';
import { getOnboardingFlow } from '../services/clientWebsite';

const OnboardingNotification = () => {
  const [showNotification, setShowNotification] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      try {
        const response = await getOnboardingFlow();
        if (response && response.data && !response.data.isCompleted) {
          setShowNotification(true);
        }
      } catch (error) {
        console.error('Error checking onboarding status:', error);
      }
    };

    checkOnboardingStatus();
  }, []);

  if (!showNotification || location.pathname === '/onboarding-questions') return null;

  return (
    <div className="onboarding-notification" onClick={() => navigate('/onboarding-questions')}>
      <div className="onboarding-icon">⚡</div>
      <div className="onboarding-content">
        <div className="onboarding-title">Complete Your Onboarding</div>
        <div className="onboarding-message">You have pending onboarding questions.</div>
      </div>
    </div>
  );
};

export default OnboardingNotification;